<template>
    <basic-content-layout>
        <component
            :is="landingPageComponent"
            :content="content"
            v-if="!isLoading && Object.keys(content).length"
        ></component>

        <div class="container mb-5" v-if="isLoading">
            <b-skeleton  width="40%" height="4.209rem" class="mb-5"></b-skeleton>
            <div class="row">
                <div class="col-12 mb-3">
                    <b-skeleton width="60%" height="1rem"></b-skeleton>
                    <b-skeleton width="36%" height="1rem"></b-skeleton>
                    <b-skeleton width="45%" height="1rem"></b-skeleton>
                    <b-skeleton width="55%" height="1rem"></b-skeleton>
                </div>
            </div>
        </div>
    </basic-content-layout>
</template>
<script>
import PresetLandingPageDefault from '../../components/organisms/PresetLandingPageDefault.vue';
import { BSkeleton } from "bootstrap-vue";

export default {
    components: {
        BasicContentLayout: () => import('../../layouts/BasicContentLayout.vue'), //lazy load so that BasicContentLayout is not rendered when landing page is not active and redirect to catalog is made instead
        BSkeleton,
        PresetLandingPageDefault
    },
    data() {
        return {
            data: '',
            isLoading: true,
            error: false,
            whitelabel: this.$root.whitelabel.state.settings,
            meta_description: '',
        }
    },
    methods: {
        getContent() {
            this.error = false
            this.isLoading = true
            const language = this.$i18n.locale.startsWith('de-DE') ? 'de_DE' : this.$i18n.locale.substring(0, 2);

            this.$axios.post('api/v1/content/get_page', {
                slug: 'landing-page',
                language: language
            })
                .then(response => {
                    this.isLoading = false
                    this.data = response.data.payload.data
                    this.content = JSON.parse(this.data.content)
                    if (this.data.meta_description !== undefined) {
                        this.meta_description = this.data.meta_description;
                    }
                })
                .catch(error => {
                    this.error = true
                    this.title = '404 not found'
                    this.$emit('updateHead')
                });
        },
        handleClosedShop() {
            const isClosed = this.$root.whitelabel.setting('accessibility') === 'closed'
            const whitelist = this.$root.whitelabel.setting('accessibility_whitelist')
            this.whitelistPages = whitelist ? whitelist.split('\r\n') : null

            if(isClosed) {
                if (!this.$root.user.isLoggedIn()) {
                    if(this.whitelistPages !== null) {
                        if(!this.refererIsOnWhitelist()){
                            this.redirectToLogin()
                        }
                    } else {
                        this.redirectToLogin()
                    }
                }
            }
        },
        redirectToLogin () {
            this.$goTo('login')
        },
        refererIsOnWhitelist () {
            const refererPage = document.getElementById('referer').value
            let isOneWhitelist = false

            this.whitelistPages.forEach(value => {
                if(refererPage.includes(value)){
                    isOneWhitelist = true
                }
            });

            return isOneWhitelist
        },

        removeOldMetaDescription() {
            const el = document.querySelector("[name='description']");
            if (el !== null) {
                el.remove();
            }
        },
    },
    mounted() {
        if (!this.$root.whitelabel.setting('landing_page_published')) {
            this.$goTo('catalog')
        }
        this.handleClosedShop()
        this.getContent()
    },
    watch: {
        '$route.params.slug'() {
            this.getContent();
        },
        data() {
            if (this.data !== null){
                this.title = this.data.title
                this.$emit('updateHead')
            }
        }
    },
    computed: {
        pageContent() {
            return this.data ? this.data.content : ''
        },
        landingPageComponent() {
            switch(this.data.preset) {
                case 'preset-1':
                    // return todo: implement feature someday in the future
                    break;
                default:
                    return 'preset-landing-page-default'
            }
        }
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.landing-page.title')
            }
        },
        meta: function () {
            this.removeOldMetaDescription();

            if (this.meta_description !== null) {
                return [
                    { name: 'description', content: this.meta_description },
                ]
            }
        }
    }
}
</script>
